import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface DialogBoxProps {
  open: boolean;
  title: string;
  content?: string;
  contentElement?: React.ReactNode;
  handleClose: () => void;
  handleConfirm: () => void;
}

// currently making sure that title and action not shown in smartfilter while using contentElement

export const DialogBoxComp: React.FC<DialogBoxProps> = ({
  open,
  title,
  content,
  handleClose,
  handleConfirm,
  contentElement,
}) => (
  <Dialog
    open={open}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    {!contentElement && (
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    )}

    <DialogContent>
      {contentElement ? (
        contentElement
      ) : (
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      )}
    </DialogContent>
    {!contentElement && (
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    )}
  </Dialog>
);
